/**
 * Perform a join on an array of strings where the last separator is different
 * E.g. ['a', 'b', 'c'] with firstSeparator = ', ' and secondSeparator = ' and ' will return 'a, b and c'
 * @param strings - Array of strings
 * @param firstSeparator - First separator
 * @param secondSeparator - Second separator
 * @returns string
 */
export function joinWithDifferentLastSeparator(
  strings: string[],
  firstSeparator: string,
  secondSeparator: string,
) {
  return strings
    .slice(0, -1)
    .join(firstSeparator)
    .concat(strings.length > 1 ? secondSeparator : '', strings.slice(-1)[0]);
}
